import React, { memo, useEffect } from 'react';
import { Text } from 'hoi-poi-ui-next';
import { Player } from '@lottiefiles/react-lottie-player';
import * as Tracking from 'utils/tracking';
import { getLang } from 'utils/literals';
import { sha1BadlyProgrammedByMobile } from 'utils/fm';
import { createImplementation, checkImplementation } from 'services/ExternalService';
import Context from 'managers/Context';

import RocketGif from './rocketGif.json';

const SignupCreating = memo(({ t, data, onStep, active }) => {
    useEffect(() => {
        if (!active || !data) return;

        Tracking.logEvent({
            event: 'signup',
            functionality: 'rocketUp',
            platform: 'web',
        });

        const apiData = {
            comercials: data.current?.teamSize?.value,
            email: data.current.email,
            language: window.navigator.language,
            jobtitle: data.current?.role?.value,
            phone: `${data.current.phonePrefix}${data.current.phone || ''}`,
            name: data.current.name,
            newsletter: data.current.checks.newsletter || false,
            password: data.current.password,
            privacyPolicy: data.current.checks.privacyAndTermsPolicy,
            termsAndConditions: data.current.checks.privacyAndTermsPolicy,
            type: 'smbtrial',
            coordinates: {
                latitude: data.current.latitude,
                longitude: data.current.longitude,
            },
            implementationName: data.current.companyName,
            timeZoneCode: data.current.timeZone,
        };

        let externalToken;
        let attemps = 0;
        const MAX_ATTEMPS = 15;
        const ATTEMP_INTERVAL = 1500;
        const sessionData = {
            email: data.current.email,
            password: data.current.password,
        };
        Context.domainManager
            .getExternalToken()
            .then((data) => (externalToken = data.token))
            .then(() => createImplementation(externalToken, apiData))
            .then(({ data }) => {
                const interval = setInterval(() => {
                    attemps++;
                    checkImplementation(externalToken, data?.tag)
                        .then(({ data }) => {
                            if (data?.status === 1) {
                                clearInterval(interval);
                                Tracking.identify(`${data.userId}_${data.implementationId}`);
                                Tracking.logEvent({
                                    event: 'signup',
                                    functionality: 'rocketUpCompleted',
                                    platform: 'web',
                                });

                                if (window.top !== window.self && window.parent) {
                                    window.parent.postMessage(
                                        {
                                            sender: 'signup_completed',
                                            user: encodeURIComponent(sessionData.email),
                                            token: sha1BadlyProgrammedByMobile(
                                                `${sessionData.email}|${sessionData.password}`,
                                            ),
                                        },
                                        '*',
                                    );
                                } else {
                                    Context.sessionManager.removeSessionData();
                                    Context.sessionManager.initSession(
                                        sessionData.email,
                                        sessionData.password,
                                    );
                                }
                            } else if (data?.error || attemps === MAX_ATTEMPS) {
                                console.error(data?.error);
                                clearInterval(interval);
                                onStep(1);
                            }
                        })
                        .catch((e) => {
                            console.error(e);
                            clearInterval(interval);
                            onStep(1);
                        });
                }, ATTEMP_INTERVAL);
            })
            .catch((e) => {
                console.error(e);
                onStep(1);
            });
    }, [active, data, onStep]);

    return (
        <div className="signup__creating">
            <div className="signup__loading">
                <Text type="h6" isHighlighted>
                    {t('label_signup_creating')}
                </Text>
                <Player autoplay loop src={RocketGif}></Player>
            </div>
        </div>
    );
});

export default SignupCreating;
